import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'

/**
 * useScrollTop
 * Wait for a navigation event, and then force the browser to scroll to the
 * beginning of the page
 */
const useScrollTop = (selectedElement?: Element | null) => {
  const element = selectedElement || window
  const history = useHistory()

  useEffect(() => {
    const disconnect = history.listen(() => element.scrollTo(0, 0))
    return () => disconnect()
  }, [history, element])
}

export default useScrollTop
